"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdapterTransformer = void 0;
const ListenerCollection_1 = require("./ListenerCollection");
const IProduceValueEvents_1 = require("./IProduceValueEvents");
class AdapterTransformer {
    constructor(adapter, producer) {
        this.listenerCollection = new ListenerCollection_1.ListenerCollection();
        this.adapter = adapter;
        producer.registerValueEventListener((status, error, value) => {
            const transformed = this.transformValueEvent(status, error, value);
            this.invokeRegisteredListeners(...transformed);
        });
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
    transformValueEvent(status, error, value) {
        if (status !== IProduceValueEvents_1.ValueStatus.Ok) {
            return [status, error, null];
        }
        if (!this.hasValue(value)) {
            return [IProduceValueEvents_1.ValueStatus.Unavailable, null, null];
        }
        return [IProduceValueEvents_1.ValueStatus.Ok, null, this.transformValues(value)];
    }
    hasValue(value) {
        if (value === null || typeof value !== "object") {
            return false;
        }
        return true;
    }
    transformValues(value) {
        return this.adapter(value);
    }
    invokeRegisteredListeners(status, error, value) {
        this.listenerCollection.invoke(status, error, value);
    }
}
exports.AdapterTransformer = AdapterTransformer;
//# sourceMappingURL=AdapterTransformer.js.map